/**
 * Centralized logger utility for Meduler application
 * Controls log output based on environment (development vs. production)
 * In production, only critical errors are displayed to reduce console noise
 */

// Always disable verbose logging regardless of environment
const isDevelopment = false; // Force production logging behavior

/**
 * Logger utility that strictly controls log output based on environment
 * Only critical errors will be shown to keep logs clean
 * IMPORTANT: All info and warn logs are disabled completely
 */
const logger = {
  /**
   * Log information messages - COMPLETELY DISABLED for cleaner console
   * To enable logging locally for debugging, use logger.forceLog
   */
  info: (message: string, ...args: unknown[]): void => {
    // Completely disabled - no logs in any environment
    // To explicitly log something important, use logger.forceLog
  },

  /**
   * Log warning messages - COMPLETELY DISABLED for cleaner console
   * To enable logging locally for debugging, use logger.forceLog
   */
  warn: (message: string, ...args: unknown[]): void => {
    // Completely disabled - no logs in any environment
    // To explicitly log something important, use logger.forceLog
  },

  /**
   * Log error messages (only critical errors in production)
   * @param message Error message
   * @param args Additional arguments
   * @param critical Set to true if this is a critical error that should appear in production
   */
  error: (message: string, ...args: unknown[]): void => {
    const lastArg = args.length > 0 ? args[args.length - 1] : null;
    const isCritical = lastArg === true; // Check if the last argument is a boolean flag
    
    if (isDevelopment || isCritical) {
      
    }
    // Non-critical errors are suppressed in production
  },

  /**
   * Force logging even in production (use sparingly only for critical information)
   * This should almost never be used except for critical operational messages
   */
  forceLog: (message: string, ...args: unknown[]): void => {
    
  }
};

export default logger;
